<template>
  <section>
    <CommonAccordion
      v-for="(requisite,index) in value"
      :key="index"
      :autoExpand="editingIndex === index"
      :accordionTitle1="true"
      class="rounded-5 mb-2"
      style="background-color:#FCFCFC"
    >
      <template #header>
        <div class="d-flex w-100 p-3">
          <span class="flex-1 text-left">{{ requisite.name || 'Untitled Requirement' }}</span>
          <span>
            <AppBadge v-if="requisite.showInCatalog">Shown in catalog</AppBadge>
          </span>
        </div>
      </template>
      <template #content>
        <section
          class="p-3"
          :data-test="`advancedRequisiteContent${index}`"
        >
          <AdvanceRequisite
            :disabled="false"
            :value="requisite"
            :editing="editingIndex === index"
            :config="config"
            @editing="setEditing(index,$event)"
            @delete="deleteRequisite(index)"
            @input="updateRequisite(index,$event)"
          />
        </section>
      </template>
    </CommonAccordion>
    <AppButton
      :raised="true"
      @click="addRequisite"
    >
      <AppIcon
        name="add"
        class="mr-2"
      />Add Requirement
    </AppButton>
  </section>
</template>

<script>
import { putAt } from '@shared/utils/array'
import CommonAccordion from '@/components/Common/CommonAccordion'
import AdvanceRequisite from './AdvanceRequisite'
import FormMixin from '@/components/Forms/FormMixin'
import { SHOW_IN_CATALOG_DEFAULT_VALUE } from '@shared/constants/requisites'

export default {
  mixins: [ FormMixin ],
  components: {
    CommonAccordion,
    AdvanceRequisite,
  },

  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
  },
  data () {
    return { editingIndex: null }
  },
  setup (props, { root }) {

    const requisitesAdvancedConfig = props?.config?.fields?.requisitesAdvanced || {}
    const requirementFieldsConfiguration = requisitesAdvancedConfig?.config?.fields || {}

    return {
      requirementFieldsConfiguration,
    }
  },
  computed: {
    showInCatalogDefaultValue () {
      if (!this.requirementFieldsConfiguration) return SHOW_IN_CATALOG_DEFAULT_VALUE

      const fieldConfig = this.requirementFieldsConfiguration['showInCatalog'] || {}

      if (!fieldConfig.config) { return SHOW_IN_CATALOG_DEFAULT_VALUE }

      return fieldConfig.config.defaultValue
    },
  },

  methods: {
    setEditing (index, value) {
      this.editingIndex = value ? index : null
    },
    addRequisite () {
      this.editingIndex = null
      this.updateRequisites([ ...this.value, { name: 'Untitled Requirement', rules: [], freeFormText: '', showInCatalog: this.showInCatalogDefaultValue } ])
      this.editingIndex = this.value.length // Setting it to length because it'll take a little time to get the updated value from the parent
    },
    updateRequisite (index, requisite) {
      this.updateRequisites(putAt(this.value, index, requisite))
    },
    deleteRequisite (index) {
      this.editingIndex = null
      this.updateRequisites(this.value.filter((r, i) => i !== index))
    },
    updateRequisites (requisites) {
      this.$emit('input', requisites)
    },
  },
}
</script>
